import { AlertDialog } from "radix-ui";
import { ReactNode } from "react";

interface IAlertRootProps {
  children: ReactNode;
  open: boolean;
  setOpen: (open: boolean) => void;
}
export default function AlertRoot(props: IAlertRootProps) {
  const { children, open, setOpen } = props;
  return (
    <AlertDialog.Root open={open} onOpenChange={setOpen}>
      {children}
    </AlertDialog.Root>
  );
}

interface IAlertProps {
  title: ReactNode;
  description: ReactNode;
  cancelButton?: ReactNode;
  actionButton?: ReactNode;
}

export const Alert = (props: IAlertProps) => {
  const { title, description, cancelButton, actionButton } = props;
  return (
    <AlertDialog.Portal>
      <AlertDialog.Overlay className="c-alert-overlay">
        <AlertDialog.Content className="c-alert">
          <AlertDialog.Title className="c-alert-title">
            {title}
          </AlertDialog.Title>

          <AlertDialog.Description>{description}</AlertDialog.Description>
          <div className="c-alert-footer">
            {cancelButton && (
              <AlertDialog.Cancel asChild>{cancelButton}</AlertDialog.Cancel>
            )}
            {actionButton && (
              <AlertDialog.Action asChild>{actionButton}</AlertDialog.Action>
            )}
          </div>
        </AlertDialog.Content>
      </AlertDialog.Overlay>
    </AlertDialog.Portal>
  );
};
